import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Background from '../../components/Background/Background'
import FlexSection from '../../components/FlexSection/FlexSection'
import Title from '../../components/Title/Title'
import SelectedSex from '../../components/SelectedSex/SelectedSex'
import Selector from '../../components/Selector/Selector'
import Image from '../../components/Image/Image'

import boxerShorts from './boxer-shorts.svg'
import diaper from './diaper.svg'

const CURRENT_STEP_NUMBER = 6
const NEXT_STEP_URL = 'skjer-pa-dagen'

class Diaper extends Component {
  componentDidMount () {
    this.props.initStep(CURRENT_STEP_NUMBER, NEXT_STEP_URL)
  }

  render () {
    const { updateScore, currentSelectedAnswer, selectedSex } = this.props

    return (
      <Background color="#FFB297">
        <FlexSection>
          <Title>
            Bruker <SelectedSex selectedSex={selectedSex} /> bleie?
          </Title>
          <div className="flex justify-around ph2">
            <Selector
              updateScore={updateScore}
              score={1}
              id={1}
              currentSelectedAnswer={currentSelectedAnswer}
              label="Ja"
              visibleLabel
              stepNumber={CURRENT_STEP_NUMBER}
              answerString="bruker bleie"
            >
              <Image src={diaper} alt="bleie" />
            </Selector>
            <Selector
              updateScore={updateScore}
              score={1}
              id={2}
              currentSelectedAnswer={currentSelectedAnswer}
              label="Nei"
              visibleLabel
              stepNumber={CURRENT_STEP_NUMBER}
              answerString="ikke bruker bleie"
            >
              <Image src={boxerShorts} alt="underbukse" />
            </Selector>
          </div>
        </FlexSection>
      </Background>
    )
  }
}

Diaper.propTypes = {
  updateScore: PropTypes.func.isRequired,
  initStep: PropTypes.func.isRequired,
  currentSelectedAnswer: PropTypes.number
}

export default Diaper



// WEBPACK FOOTER //
// ./src/containers/Diaper/Diaper.js